module.exports = __webpack_public_path__ + "img/tips-sun.b50dcda6.svg";